// import { Injectable } from '@angular/core';
// import { io, Socket } from 'socket.io-client';

// import { BehaviorSubject, filter, map, Observable, tap } from 'rxjs';
// import { environment } from '../../../environments/environment';
// import { ChatRoom, Message, User } from './types';
// import { HapticsService } from 'haptics.serivce';
// import { NetworkStatusService } from 'app/network-status.service';
// import { Client } from '@stomp/stompjs';
// import * as SockJS from 'sockjs-client';

// @Injectable({
//     providedIn: 'root',
// })
// export class WebSocketService {
//     private socket: Socket;

//     private websocketUrl = environment.websocketUrl;

//     private conflictSubject = new BehaviorSubject<{ direction: 'CREATED' | 'RESOLVED' }>(null);
//     private appointmentChangedSubject = new BehaviorSubject<any>(null);
//     private messageSubject = new BehaviorSubject<Message>(null);
//     private messagesSubject = new BehaviorSubject<Message[]>(null);
//     private messageDeletedSubject = new BehaviorSubject<{ messageId: string }>(null);
//     private chatRoomsSubject = new BehaviorSubject<ChatRoom[]>(null);
//     private conversionProgress = new BehaviorSubject<any>(null);
//     private inviteNotification = new BehaviorSubject<any>(null);
//     private isTypingSubject = new BehaviorSubject<{ user:User, chatRoomId: string, isTyping: boolean }>(null);
//     private messasageStateChangedSubject = new BehaviorSubject<{ messageId: string, userId: string, status: any }>(null);

//     constructor(
//         private hapticsService: HapticsService,
//         private networkStatusService: NetworkStatusService
//     ) { }

//     /**
//      * Initialize the WebSocket connection.
//      * @param token The JWT token for authentication.
//      */
//     initConnection(token: string): void {

//         if (!token) {
//             return;
//         }

//         if (this.socket && this.socket.connected) {
//             console.warn('WebSocket already connected.');
//             return;
//         }

//         this.socket = io(`${this.websocketUrl}`, {
//             auth: { token },
//             transports: ['websocket'],
//             reconnection: true,
//             reconnectionAttempts: 5,
//             reconnectionDelay: 1000,
//         });

//         this.registerEventListeners();
//     }

//     /**
//      * Register listeners for WebSocket events.
//      */
//     private registerEventListeners(): void {
//         this.socket.on('connect', () => {
//             this.networkStatusService.setWebSocketStatus(true);
//             console.log('WebSocket connected:', this.socket.id);
//         });

//         this.socket.on('disconnect', (reason) => {
//             this.networkStatusService.setWebSocketStatus(false);
//             console.log('WebSocket disconnected:', reason);
//         });

//         this.socket.on('reconnect', (attempt) => {
//             this.networkStatusService.setWebSocketStatus(true);
//             console.log('WebSocket reconnected after', attempt, 'attempt(s)');
//         });

//         this.socket.on('reconnect_error', (error) => {
//             this.networkStatusService.setWebSocketStatus(false);
//             console.error('WebSocket reconnection error:', error);
//         });

//         this.socket.on('connect_error', (error) => {
//             this.networkStatusService.setWebSocketStatus(false);
//             console.error('WebSocket connection error:', error);
//         });

//         this.socket.on('conflict', (conflict) => {
//             this.conflictSubject.next(conflict);
//         });

//         this.socket.on('appointmentChanged', (payload) => {
//             this.appointmentChangedSubject.next(payload);
//         });

//         // Listen for new messages
//         this.socket.on('newMessage', (message: Message) => {
//             this.hapticsService.vibrate();
//             this.messageSubject.next(message);
//         });

//         // Listen for fetched messages
//         this.socket.on('messages', (messages: Message[]) => {
//             this.messagesSubject.next(messages);
//         });

//         // Listen for deleted messages
//         this.socket.on('messageDeleted', (payload: { messageId: string }) => {
//             this.messageDeletedSubject.next(payload);
//         });

//         this.socket.on('chatRooms', (chatRooms: ChatRoom[]) => {
//             this.chatRoomsSubject.next(chatRooms);
//         });

//         this.socket.on('conversionProgress', (event) => {
//             this.conversionProgress.next(event);
//         });

//         this.socket.on('inviteNotification', (event) => {
//             this.inviteNotification.next(event);
//         })

//         this.socket.on('messageDeleted', (payload: { messageId: string }) => {
//             this.messageDeletedSubject.next(payload);
//         });

//         this.socket.on('messageStateChanged', (payload: { messageId: string, userId: string, status: 'SENT' | 'DELIVERED' | 'READ' }) => {
//             this.messasageStateChangedSubject.next(payload);
//         });

//         this.socket.on('isTyping', (payload: { user: User, chatRoomId: string, isTyping: boolean }) => {
//             this.isTypingSubject.next(payload);
//         });

//     }

//     /**
//      * Subscribe to conflict notifications.
//      * @returns An observable of conflict notifications.
//      */
//     onConflictsUpdated(): Observable<{ direction: 'CREATED' | 'RESOLVED' }> {
//         return this.conflictSubject.asObservable().pipe(filter(conflict => conflict !== null));
//     }

//     onAppointmentChanged(): Observable<any> {
//         return this.appointmentChangedSubject.asObservable().pipe(filter(payload => payload !== null));
//     }

//     onInviteNotification(): Observable<any> {
//         return this.inviteNotification.asObservable().pipe(filter(payload => payload !== null));
//     }

//     /**
//      * Send a message to a chat room.
//      * @param content The message content.
//      * @param chatRoomId The chat room ID.
//      */
//     sendMessage(content: string, chatRoomId: string, quotedMessageId?: string): void {
//         this.socket.emit('sendMessage', { content, chatRoomId, quotedMessageId });
//     }

//     /**
//      * Fetch messages for a chat room.
//      * @param chatRoomId The chat room ID.
//      */
//     getMessages(chatRoomId: string): void {
//         this.socket.emit('getMessages', { chatRoomId });
//     }

//     onIsTyping(): Observable<{ user: User, chatRoomId: string, isTyping: boolean }> {
//         return this.isTypingSubject.asObservable().pipe(
//             filter(payload => payload?.chatRoomId !== null && payload?.user !== null),
//             map(payload => payload)
//         );
//     }

//     /**
//      * Mark a message as read.
//      * @param messageId The message ID.
//      */
//     readMessage(messageId: string, chatRoomId: string, status: "DELIVERED" | "READ"): void {
//         this.socket.emit('readMessage', { messageId, chatRoomId, status });
//     }

//     /**
//      * Delete a message.
//      * @param messageId The message ID.
//      */
//     deleteMessage(messageId: string, chatRoomId: string): void {
//         this.socket.emit('deleteMessage', { messageId, chatRoomId });
//     }

//     /**
//      * Subscribe to new messages.
//      * @returns An observable of new messages.
//      */
//     onNewMessage(): Observable<Message> {
//         return this.messageSubject.asObservable().pipe(filter((message) => message !== null));
//     }

//     onMessageStatusChanged(): Observable<{ messageId: string, userId: string, status: any }> {
//         return this.messasageStateChangedSubject.asObservable().pipe(filter((payload) => payload !== null));
//     }

//     /**
//      * Subscribe to fetched messages.
//      * @returns An observable of fetched messages.
//      */
//     onMessages(): Observable<Message[]> {
//         return this.messagesSubject.asObservable().pipe(filter((messages) => messages !== null));
//     }

//     /**
//      * Subscribe to deleted messages.
//      * @returns An observable of deleted messages.
//      */
//     onMessageDeleted(): Observable<{ messageId: string }> {
//         return this.messageDeletedSubject.asObservable().pipe(filter((payload) => payload !== null));
//     }

//     /**
//      * Fetch the user's chatrooms.
//      */
//     getChatRooms(): void {
//         this.socket.emit('getChatRooms');
//     }

//     /**
//      * Subscribe to the user's chatrooms.
//      * @returns An observable of chatrooms.
//      */
//     onChatRooms(): Observable<ChatRoom[]> {
//         return this.chatRoomsSubject.asObservable().pipe(filter((rooms) => rooms !== null));
//     }

//      /**
//      * Fetch the initial list of messages in a chatroom.
//      */
//      fetchChatroomMessages(chatroomId: string): Observable<any[]> {
//         this.socket.emit('getMessages', { chatRoomId: chatroomId });
//         return this.messagesSubject.asObservable();
//     }

//     /**
//      * Join a chatroom to start receiving messages.
//      */
//     joinChatroom(chatroomId: string): void {
//         this.socket.emit('joinChatroom', { chatRoomId: chatroomId });
//     }

//     /**
//      * Leave the chatroom.
//      */
//     leaveChatroom(chatroomId: string): void {
//         this.socket.emit('leaveChatroom', { chatRoomId: chatroomId });
//     }


//     /**
//      * Disconnect from the WebSocket server.
//      */
//     disconnect(): void {
//         if (this.socket) {
//             this.socket.disconnect();
//         }
//     }

//     sendFile(file: File, chatroomId: string): void {
//         const formData = new FormData();
//         formData.append('file', file);
//         formData.append('chatroomId', chatroomId);

//         this.socket.emit('uploadFile', formData);
//     }

//     sendImage(file: File, chatRoomId: string): void {
//         const reader = new FileReader();
//         reader.onload = () => {
//             this.socket.emit('sendFile', {
//                 chatRoomId,
//                 fileName: file.name,
//                 fileData: reader.result, // Base64 encoded file
//             });
//         };
//         reader.readAsDataURL(file); // Convert file to Base64
//     }


//     sendTyping(chatRoomId: string, isTyping: boolean): void {
//         this.socket.emit('isTyping', { chatRoomId, isTyping });
//     }

//     onConversionProgress(): Observable<any> {
//         return this.conversionProgress.asObservable();
//     }

// }
// src/app/api/web-socket.service.ts



import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, filter, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChatRoom, Message, User } from './types';
import { HapticsService } from 'haptics.serivce';
import { NetworkStatusService } from 'app/network-status.service';
import { Client, IMessage, StompHeaders, StompSubscription } from '@stomp/stompjs';
import SockJS from 'sockjs-client/dist/sockjs';

// ====== PASSE DIESE PFAD-KONSTANTEN AN DEIN BACKEND AN ======
const WS_ENDPOINT = '/ws';                 // Spring: .addEndpoint("/ws").withSockJS()
const APP_PREFIX = '/app';                // Client -> Server
const TOPIC = '/topic';              // Broadcast vom Server
const USER_QUEUE = '/user/queue';         // Nur an eingeloggten User

// Send-Destinations (Client -> Server)
const SEND = {
    SEND_MESSAGE: `${APP_PREFIX}/chat.send`,          // {content, chatRoomId, quotedMessageId?}
    GET_MESSAGES: `${APP_PREFIX}/chat.fetch`,         // {chatRoomId, skip?}
    JOIN_CHATROOM: `${APP_PREFIX}/chat.join`,          // {chatRoomId}
    LEAVE_CHATROOM: `${APP_PREFIX}/chat.leave`,         // {chatRoomId}
    READ_MESSAGE: `${APP_PREFIX}/chat.read`,          // {messageId, chatRoomId, status}
    DELETE_MESSAGE: `${APP_PREFIX}/chat.delete`,        // {messageId, chatRoomId}
    GET_CHATROOMS: `${APP_PREFIX}/chat.rooms`,         // {}
    IS_TYPING: `${APP_PREFIX}/chat.typing`,        // {chatRoomId, isTyping}
    UPLOAD_FILE: `${APP_PREFIX}/chat.upload`,        // multipart separat; hier evt. Meta
};

// Subscriptions (Server -> Client)
const SUB = {
    CONFLICT: `${TOPIC}/conflict`,
    APPOINTMENT_CHANGED: `${TOPIC}/appointmentChanged`,
    CONVERSION_PROGRESS: `${USER_QUEUE}/conversionProgress`,

    NEW_MESSAGE: `${USER_QUEUE}/chat/newMessage`,
    MESSAGES: `${USER_QUEUE}/chat/messages`,
    MESSAGE_DELETED: `${USER_QUEUE}/chat/messageDeleted`,
    MESSAGE_STATE: `${USER_QUEUE}/chat/messageStateChanged`,
    CHAT_ROOMS: `${USER_QUEUE}/chat/rooms`,
    INVITE_NOTIFICATION: `${USER_QUEUE}/invite`,

    IS_TYPING: `${USER_QUEUE}/chat/isTyping`,
};

type Handler<T = any> = (msg: T) => void;

@Injectable({ providedIn: 'root' })
export class WebSocketService {
    private websocketUrl = environment.websocketUrl;

    private stompClient: Client | null = null;
    private stompSubs = new Map<string, StompSubscription>();
    private currentToken: string | null = null;

    // Subjects wie vorher
    private conflictSubject = new BehaviorSubject<{ direction: 'CREATED' | 'RESOLVED' }>(null);
    private appointmentChangedSubject = new BehaviorSubject<any>(null);
    private messageSubject = new BehaviorSubject<Message>(null);
    private messagesSubject = new BehaviorSubject<Message[]>(null);
    private messageDeletedSubject = new BehaviorSubject<{ messageId: string }>(null);
    private chatRoomsSubject = new BehaviorSubject<ChatRoom[]>(null);
    private conversionProgress = new BehaviorSubject<any>(null);
    private inviteNotification = new BehaviorSubject<any>(null);
    private isTypingSubject = new BehaviorSubject<{ user: User, chatRoomId: string, isTyping: boolean }>(null);
    private messasageStateChangedSubject = new BehaviorSubject<{ messageId: string, userId: string, status: any }>(null);

    constructor(
        private hapticsService: HapticsService,
        private networkStatusService: NetworkStatusService,
    ) { }

    // ==== Public API bleibt wie vorher ====

    initConnection(token: string) {
        return;
        if (!token) return;
        this.currentToken = token;

        // ggf. alte Verbindung schließen
        if (this.stompClient?.active) {
            this.stompClient.deactivate().finally(() => this.start());
        } else {
            this.start();
        }
    }

    disconnect(): void {
        this.unsubscribeAll();
        this.stompClient?.deactivate();
        this.stompClient = null;
        this.networkStatusService.setWebSocketStatus(false);
    }

    // -> Nach Token-Refresh aufrufen
    updateAuth(token: string) {
        this.initConnection(token);
    }

    // ----------------- „emit“ Mappings (Client -> Server) -----------------

    sendMessage(content: string, chatRoomId: string, quotedMessageId?: string): void {
        this.send(SEND.SEND_MESSAGE, { content, chatRoomId, quotedMessageId });
    }

    fetchChatroomMessages(chatRoomId: string, skip?: number): Observable<any[]> {
        this.send(SEND.GET_MESSAGES, { chatRoomId, skip });
        return this.messagesSubject.asObservable().pipe(
            filter(messages => messages !== null),
            map(messages => messages)
        );
    }

    readMessage(messageId: string, chatRoomId: string, status: 'DELIVERED' | 'READ'): void {
        this.send(SEND.READ_MESSAGE, { messageId, chatRoomId, status });
    }

    deleteMessage(messageId: string, chatRoomId: string): void {
        this.send(SEND.DELETE_MESSAGE, { messageId, chatRoomId });
    }

    getChatRooms(): void {
        this.send(SEND.GET_CHATROOMS, {});
    }

    joinChatroom(chatRoomId: string): void {
        this.send(SEND.JOIN_CHATROOM, { chatRoomId });
    }

    leaveChatroom(chatRoomId: string): void {
        this.send(SEND.LEAVE_CHATROOM, { chatRoomId });
    }

    sendTyping(chatRoomId: string, isTyping: boolean): void {
        this.send(SEND.IS_TYPING, { chatRoomId, isTyping });
    }

    // Dateien: weiterhin via HTTP an deinen Upload‑Endpoint schicken (empfohlen).
    // Die alten socket.io-emit('uploadFile') Aufrufe ersetzt du am besten durch ApiService-HTTP.

    // ----------------- „on“ Mappings (Server -> Client) -----------------

    onConflictsUpdated(): Observable<{ direction: 'CREATED' | 'RESOLVED' }> {
        return this.conflictSubject.asObservable().pipe(filter(Boolean));
    }
    onAppointmentChanged(): Observable<any> {
        return this.appointmentChangedSubject.asObservable().pipe(filter(Boolean));
    }
    onInviteNotification(): Observable<any> {
        return this.inviteNotification.asObservable().pipe(filter(Boolean));
    }
    onNewMessage(): Observable<Message> {
        return this.messageSubject.asObservable().pipe(filter(Boolean));
    }
    onMessages(): Observable<Message[]> {
        return this.messagesSubject.asObservable().pipe(filter(Boolean));
    }
    onMessageDeleted(): Observable<{ messageId: string }> {
        return this.messageDeletedSubject.asObservable().pipe(filter(Boolean));
    }
    onMessageStatusChanged(): Observable<{ messageId: string, userId: string, status: any }> {
        return this.messasageStateChangedSubject.asObservable().pipe(filter(Boolean));
    }
    onChatRooms(): Observable<ChatRoom[]> {
        return this.chatRoomsSubject.asObservable().pipe(filter(Boolean));
    }
    onIsTyping(): Observable<{ user: User, chatRoomId: string, isTyping: boolean }> {
        return this.isTypingSubject.asObservable().pipe(
            filter(p => !!p?.chatRoomId && !!p?.user),
            map(p => p)
        );
    }
    onConversionProgress(): Observable<any> {
        return this.conversionProgress.asObservable();
    }

    // ================= Interna =================

    private start() {
        const token = this.currentToken!;
        const url = `${this.websocketUrl}${WS_ENDPOINT}`;

        const client = new Client({
            webSocketFactory: () => new SockJS(url) as any,
            connectHeaders: { Authorization: `Bearer ${token}` } as StompHeaders,
            reconnectDelay: 1000,
            heartbeatIncoming: 10000,
            heartbeatOutgoing: 10000,
            debug: () => { }
        });

        client.onConnect = () => {
            () => this.networkStatusService.setWebSocketStatus(true);
            // Subscriptions setzen
            this.subscribe(SUB.CONFLICT, (p) => this.conflictSubject.next(p));
            this.subscribe(SUB.APPOINTMENT_CHANGED, (p) => this.appointmentChangedSubject.next(p));
            this.subscribe(SUB.CONVERSION_PROGRESS, (p) => this.conversionProgress.next(p));
            this.subscribe(SUB.NEW_MESSAGE, (m: Message) => { this.hapticsService.vibrate(); this.messageSubject.next(m); });
            this.subscribe(SUB.MESSAGES, (ms: Message[]) => this.messagesSubject.next(ms));
            this.subscribe(SUB.MESSAGE_DELETED, (p: { messageId: string }) => this.messageDeletedSubject.next(p));
            this.subscribe(SUB.MESSAGE_STATE, (p: { messageId: string; userId: string; status: any }) => this.messasageStateChangedSubject.next(p));
            this.subscribe(SUB.CHAT_ROOMS, (rooms: ChatRoom[]) => this.chatRoomsSubject.next(rooms));
            this.subscribe(SUB.INVITE_NOTIFICATION, (evt) => this.inviteNotification.next(evt));
            this.subscribe(SUB.IS_TYPING, (p: { user: User, chatRoomId: string, isTyping: boolean }) => this.isTypingSubject.next(p));
        };

        client.onStompError = (frame) => {
            console.error('[STOMP ERROR]', frame.headers['message'], frame.body);
        };

        client.onWebSocketClose = () => {
            () => this.networkStatusService.setWebSocketStatus(false);
            // reconnectDelay übernimmt das Wiederverbinden
        };

        this.stompClient = client;
        client.activate();
    }

    private send(destination: string, body: any) {
        const payload = typeof body === 'string' ? body : JSON.stringify(body);
        if (this.stompClient?.connected) {
            this.stompClient.publish({ destination, body: payload });
        } else {
            // Leichtes Buffering: versuch nach kurzer Wartezeit nochmal
            setTimeout(() => {
                if (this.stompClient?.connected) {
                    this.stompClient.publish({ destination, body: payload });
                }
            }, 300);
        }
    }

    private subscribe<T = any>(destination: string, handler: Handler<T>) {
        // vor erneuter Subscription alte lösen
        this.stompSubs.get(destination)?.unsubscribe();
        const sub = this.stompClient!.subscribe(destination, (msg: IMessage) => {
            let data: any = msg.body;
            try { data = JSON.parse(msg.body); } catch { }
            () => handler(data as T);
        });
        this.stompSubs.set(destination, sub);
    }

    private unsubscribeAll() {
        this.stompSubs.forEach(s => s.unsubscribe());
        this.stompSubs.clear();
    }
}
